import React, { useEffect, useState, useMemo } from 'react';
import { fetchAllRecipes, fetchRecipe } from '../../api/actions';
import RecipeSearchBar from './RecipeSearchBar';
import RecipeList from './RecipeList';
import RecipeView from '../RecipeView';
import { useAuth } from '../../auth/AuthContext';
import './RecipeBrowser.css';

export default function RecipeBrowser({ onStartExecution, startingExecution }) {
    const [recipes, setRecipes] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedId, setSelectedId] = useState('');
    const [recipe, setRecipe] = useState(null);
    const [loading, setLoading] = useState(true);
    const { isAuthenticated } = useAuth();

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const items = await fetchAllRecipes();
                if (!mounted) return;
                setRecipes(items);
                if (items.length > 0 && !items.find(r => r.id === selectedId)) {
                    setSelectedId(items[0].id);
                }
            } catch (err) {
                console.error('Failed to load recipes:', err);
            }
        })();
        return () => { mounted = false; };
    }, [isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!selectedId) return;
        let mounted = true;
        setLoading(true);
        (async () => {
            try {
                const data = await fetchRecipe(selectedId);
                if (!mounted) return;
                setRecipe(data);
            } catch (err) {
                console.error('Failed to load recipe:', err);
            } finally {
                if (mounted) setLoading(false);
            }
        })();
        return () => { mounted = false; };
    }, [selectedId]);

    const filteredRecipes = useMemo(() => {
        if (!searchQuery) return recipes;
        const q = searchQuery.toLowerCase();
        return recipes.filter(r =>
            (r.name || r.id).toLowerCase().includes(q)
        );
    }, [recipes, searchQuery]);

    return (
        <div className="recipe-browser">
            <div className="browser-sidebar">
                <RecipeSearchBar value={searchQuery} onChange={setSearchQuery} />
                <RecipeList
                    recipes={filteredRecipes}
                    selectedId={selectedId}
                    onSelect={setSelectedId}
                />
            </div>
            <div className="browser-main">
                <div className="browser-toolbar">
                    {!loading && recipe && (
                        <button
                            className="start-recipe-button"
                            onClick={() => onStartExecution(selectedId)}
                            disabled={startingExecution}
                        >
                            {startingExecution ? 'Starting...' : 'Start Recipe'}
                        </button>
                    )}
                </div>

                {loading || !recipe ? (
                    <div className="browser-loading">
                        {selectedId ? 'Loading...' : 'Select a recipe'}
                    </div>
                ) : (
                    <RecipeView recipe={recipe} />
                )}
            </div>
        </div>
    );
}
